// projects/humanresources-personnel/src/assets/i18n/*/hr-per-object-relationship.json
export class HrPerObjectRelationshipKey {
    private static readonly keyPrefix = 'hrPerObjectRelationship';
    public static title = `${HrPerObjectRelationshipKey.keyPrefix}.title`;
    public static objectId = `${HrPerObjectRelationshipKey.keyPrefix}.objectId`;
    public static objectDefinitionId = `${HrPerObjectRelationshipKey.keyPrefix}.objectDefinitionId`;
    public static objectDId = `${HrPerObjectRelationshipKey.keyPrefix}.objectDId`;
    public static objectDefinitionDId = `${HrPerObjectRelationshipKey.keyPrefix}.objectDefinitionDId`;
    public static objectConnectId = `${HrPerObjectRelationshipKey.keyPrefix}.objectConnectId`;
    public static count = `${HrPerObjectRelationshipKey.keyPrefix}.count`;
}
